import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page18() {
  useEffect(() => {
    document.title = "Маяк — Страница 17"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page16" />
        <ForwardLink href="/page18" />
      </div>

      <p style={{ textAlign: "right" }}>17.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Используй это в следующий раз. Избавлю тебя<br/>
        от адских хлопот.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p>СТАРИК продолжает насмехаться над ним.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Отдышись, парень.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>Я сказал: отдышись, парень!</p>
      <p>МОЛОДОЙ скрипит зубами.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Затем спусти эту бочку вниз<br/>
        по лестнице туда, откуда ты ее взял. ‘Исправь<br/>
        свою ошибку’ или ты собираешься спалить весь<br/>
        маяк.
      </p>
      <p>
        СТАРИК взбирается по лестнице в ФОНАРНОЕ ОТДЕЛЕНИЕ. МОЛОДОЙ смотрит<br/>
        со злостью.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p>
        СТАРИК достает СВЯЗКУ КЛЮЧЕЙ, прикрепленную к цепочке часов. Полдюжины<br/>
        МЕДНЫХ <u>КЛЮЧЕЙ</u> разных размеров.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Затем позаботься об остальном.<br/>
        Ты уже опаздываешь.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p>МОЛОДОЙ наблюдает, как он отпирает дверь самым большим КЛЮЧОМ.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты слишком медлительный. Ты тупой?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Обманываешь меня.
      </p>
      <p>СТАРИК хлопает дверью и запирает ее изнутри.</p>
      <p>ЗАДЕРЖКА на МОЛОДОМ.</p>
      <p style={{ textAlign: "right" }}>17.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page16" />
        <ForwardLink href="/page18" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708111263/the-lighthouse-script/dgakqqv6sn5vhudzdvvj.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page18;
